(ns ycweb.app.pos.login
  (:require
   [rum.core :as rum]
   [ycweb.util.hash :as hash]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.util.core :as u]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.transitions :as t]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.state :as state]
   [ycweb.util.comms :as comms]
   [ycweb.components.flow :as flow]
   [ycweb.components.history :as history]
   [util.transform :as trf]))

;; Loading screen...
(rum/defc loading-screen []
  [:div
   [:div.login-screen-animation]
   [:div.login-screen.u-angled-background
    [:div
     {:class :login-screen__body}
     [:div.login-screen__main-content
      [:div.login-screen__branding-wrapper
       [:div.login-screen__branding
        [:div.login-screen__logo-wrapper
         [:img.login-screen__logo
          {:src "https://res.cloudinary.com/yuppiechef/image/upload/v1503304800/pos-ui/yuppiechef-logo-white.svg"
           :alt "Yuppiechef logo"
           :width 196
           :height 24}]]]]]]]])

;; Login screen
(rum/defcs login-screen < rum/reactive (rum/local {} ::state)
  [s app-atom]
  (let [local-atom (::state s)
        warehouse-list-atom (rum/cursor app-atom :warehouse-list)
        login-atom (rum/cursor app-atom :login)

        error-message (rum/react (rum/cursor app-atom :error))
        error-field (rum/react (rum/cursor app-atom :error-field))
        manual? (cmn/curact login-atom :manual-login)
        current-warehouse-id (int (cmn/curval (rum/cursor-in app-atom [:login :warehouse_id])))
        manual-warehouse? (if (> current-warehouse-id 0) (boolean (cmn/curact login-atom :manual-warehouse)) true)
        warehouse-list (cmn/curval warehouse-list-atom)
        current-warehouse-store (first (filter #(= current-warehouse-id (:warehouse-id %)) warehouse-list))
        blitz? (trf/toboolean (cmn/curact app-atom :blitz?))]
    [:div
     [:div.login-screen-animation]
     [:div.login-screen.u-angled-background

      [:div
       {:class [:login-screen__body]}

       [:div.login-screen__build-no-wrapper
        [:small.login-screen__build-no "BUILD NO. " (cmn/curact app-atom [:app :version])]
        [:small.login-screen__build-no "APP VER. " (cmn/curact app-atom [:device :version-name])]]

       (let [device-version (trf/tonumber (cmn/curact app-atom [:device :version-code]))
             min-version (cmn/curact app-atom [:min-apk-version (if blitz? :warehouses :stores)])]
         (when (and (pos? device-version) min-version (< device-version min-version))
           [:div.u-margin-top-8
            (feedback/feedback :warning "App Update Available"
              "Please update to the latest version.")]))

       [:div.login-screen__main-content
        [:div.login-screen__branding-wrapper
         (when (or manual-warehouse? manual?) {:class :login-screen__branding-wrapper--top})
         [:div.login-screen__branding
          [:div.login-screen__logo-wrapper
           [:img.login-screen__logo
            {:src "https://res.cloudinary.com/yuppiechef/image/upload/v1503304800/pos-ui/yuppiechef-logo-white.svg",
             :alt "Yuppiechef logo"
             :width 196
             :height 24}]]
          [:h1.u-text-center.u-text-white
           {:class (u/bem :heading [:large])}
           (when (not (empty? (:displayname current-warehouse-store)))
             [:span.heading__pretext "You're logging in to" [:span.u-hidden-from-view " "]])
           (if warehouse-list
             (or (:displayname current-warehouse-store) "No Store Selected")
             "Loading...")]]]

        [:form.login-screen__form
         (when warehouse-list
           [:div
            {:class (u/bem :toggle-block [(when (or manual-warehouse? manual?) :is-open)])}
            [:div
             {:class [:form-field (when-not (or manual-warehouse? manual?) :u-hidden)]}
             (forms/select
               "Select Function:"
               (rum/cursor app-atom :blitz?)
               (concat
                 [{:value "false" :text "Store"}]
                 [{:value "true" :text "Warehouse"}])
               {:on-dark true
                :default blitz?
                :change-fn (fn [_ v] (swap! app-atom assoc :blitz? (trf/toboolean v)))})]

            (forms/select
              (if blitz? "Select Warehouse:" "Select a Store:")
              (rum/cursor-in app-atom [:login :warehouse_id])
              (concat
                [(if blitz?
                   {:value nil :text "Select a Warehouse..."}
                   {:value nil :text "Select a Store..."})]
                (map
                  (fn [{:keys [displayname warehouse-id]}] {:value warehouse-id :text displayname})
                  (let [[default non-default]
                        [(sort-by (comp not :store-id) :displayname (filter :default warehouse-list))
                         (sort-by :displayname (remove :default warehouse-list))]]

                    (seq
                      (if blitz?
                        (->>
                          (concat default non-default)
                          (sort-by (comp not :store-id)))
                        (->>
                          (concat default non-default)
                          (remove (comp nil? :store-id))
                          (sort-by (comp not :store-id))))))))
              {:on-dark true
               :error (if (= error-field :warehouse_id) true false)
               :hint (if (and (= error-field :warehouse_id) error-message) error-message false)})])

         [:div
          {:class (u/bem :toggle-block [(when manual? :is-open)])}
          (when manual?
            (forms/input
              "Account Email Address:"
              "e.g. jane.smith@yuppiechef.com"
              (rum/cursor login-atom :username)
              {:on-dark true :type :email :auto-focus (cmn/auto-focus? app-atom)
               :error (if (= error-field :username) true false)
               :hint (if (and (= error-field :username) error-message) error-message false)}))

          (forms/input
            "Password:" ""
            (rum/cursor local-atom :pwd)
            {:on-dark true :type :password
             :error (if (= error-field :pwd) true false)
             :hint (if (and (= error-field :pwd) error-message) error-message false)})]]]

       [:aside.login-screen__footnote
        (when manual? {:class :login-screen__footnote--closed})
        [:p.u-text-center.u-text-white
         {:class (u/bem :paragraph [:flush])}
         [:i {:class (u/bem :icon [:inline :in-copy-left :barcode-scan :2-2])}]
         "Scan tag to log in"]]]

      [:div
       {:class (u/bem :call-to-action [:login-screen (when manual? :hide)])}
       [:div
        {:class (u/bem :flex-grid-group [:flush])}
        [:div
         {:class (u/bem :flex-grid-block [:1-2 :flush])}
         [:div.flex-grid-content
          (buttons/button
            "Change Store"
            #(swap! login-atom assoc :manual-warehouse (not manual-warehouse?))
            {:icon-left :location :icon-class :2-2 :full true :large true :muted true
             :opaque true :persistent true :on-dark true :text-default true :text-size 13})]]
        [:div
         {:class (u/bem :flex-grid-block [:1-2 :flush])}
         [:div.flex-grid-content
          (buttons/button
            "Manual Login"
            #(swap! login-atom assoc :manual-login true)
            {:icon-left :lock :icon-class :2-2 :full true :large true :muted true
             :opaque true :persistent true :on-dark true :text-default true :text-size 13})]]]]

      [:div
       {:class (u/bem :call-to-action [:login-screen (when-not manual? :hide)])}
       [:div
        {:class (u/bem :flex-grid-group [:flush])}
        [:div
         {:class (u/bem :flex-grid-block [:1-2 :flush])}
         [:div.flex-grid-content
          (buttons/button
            "Cancel"
            #(swap! login-atom assoc :manual-login false)
            {:icon-left :arrow-left :icon-class :2-1 :full true :large true
             :secondary true :persistent true :text-default true})]]
        [:div
         {:class (u/bem :flex-grid-block [:1-2 :flush])}
         [:div.flex-grid-content
          (buttons/button
            "Login"
            #(grid/dispatch-action app-atom :login/login (merge @login-atom @local-atom))

            {:icon-right :arrow-right :icon-class :2-2 :full true :large true
             :call-to-action true :persistent true :on-dark true :text-default true})]]]]]]))

(defmethod flow/render-screen :login [app-atom screen]
  (login-screen app-atom))

(defmethod flow/barcode-dispatch-screen :login [_ app-atom scan]
  (println "Login Scan")
  (grid/dispatch-action app-atom :login/login {:scan scan}))

(defn validate-login [app-atom login manual?]
  (let [{:keys [warehouse_id username pwd]} login
        error
        (cond
          (or
            (nil? warehouse_id)
            (not (pos? (u/parseInt warehouse_id))))
          {:error "Please select a Store" :error-field :warehouse_id}

          (and manual? (not (u/presence username)))
          {:error "Please enter a valid username" :error-field :username}

          (and manual? (not (u/presence pwd)))
          {:error "Please enter a password" :error-field :pwd}

          :else nil)]
    (if error
      (do
        (swap! app-atom merge error)
        false)
      true)))

(defmethod grid/action :login/login [app-atom {:keys [scan pwd] :as login}]
  (let [merged-login (merge (:login @app-atom) login)]
    (when (validate-login app-atom merged-login (if scan false true))
      (let [{:keys [warehouse_id] :as login} merged-login
            warehouse (first (filter #(= (u/parseInt warehouse_id) (:warehouse-id %)) (:warehouse-list @app-atom)))]

        (swap! app-atom update-in [:login] merge
          {:warehouse_id (:warehouse-id warehouse)
           :store_id (:store-id warehouse)
           :store_uuid (:store-uuid warehouse)
           :warehouse_uuid (:warehouse-uuid warehouse)})

        (swap! app-atom assoc-in [:selected-warehouse] warehouse)

        (u/set-cookie! app-atom :store_id (:store_id login))
        (toaster/open-toast app-atom :processing "Logging in" {})
        (comms/send :pos/mobile-login
          {:blitz? (trf/toboolean (:blitz? @app-atom))
           :login
           {:username (:username login)
            :pwd (when pwd (hash/md5 pwd))
            :store_id (:store-id warehouse)
            :warehouse_id warehouse_id}
           :scan scan})))))

(defmethod comms/receive :pos/mobile-login [app-atom e]
  (toaster/close-toast app-atom)
  (cond
    (= (:response/type e) :invalid-permission)
    (grid/message-modal app-atom
      {:title "Error"
       :text (:message e)
       :type :error
       :confirm-text "OK"})))

;; Locking screen
(defn lock-screen [app-atom]
  (println "App resume, Lock: ")
  (when (not= :login (get-in @app-atom [:page :screen]))
    (t/transition-prev app-atom :lock)))

(rum/defc render-lock-screen < rum/reactive (rum/local {} ::state)
  [app-atom]
  (let [unlock-atom (rum/cursor app-atom :unlock)
        error-message (rum/react (rum/cursor app-atom :error))
        error-field (rum/react (rum/cursor app-atom :error-field))
        user (rum/react (rum/cursor app-atom :user))
        state (rum/react unlock-atom)]
    [:div
     [:div.login-screen-animation]
     [:div.login-screen.u-angled-background
      [:div
       {:class [:login-screen__body]}

       [:div.login-screen__build-no-wrapper
        [:small.login-screen__build-no "Build No. " (cmn/curact app-atom [:app :version])]
        [:small.login-screen__build-no "APP Ver. " (cmn/curact app-atom [:device :version-name])]]

       [:div.login-screen__main-content
        [:div.login-screen__branding-wrapper
         {:class :login-screen__branding-wrapper--top}
         [:div.login-screen__branding
          [:div.login-screen__logo-wrapper
           [:img.login-screen__logo
            {:src "https://res.cloudinary.com/yuppiechef/image/upload/v1503304800/pos-ui/yuppiechef-logo-white.svg",
             :alt "Yuppiechef logo"
             :width 196
             :height 24}]]
          [:figure.user-account__image-wrapper
           (u/user-profile-pic user {:w 128 :h 128} "avatar  image  image--full")]
          [:h1.u-text-center.u-text-white.u-margin-top-24
           {:class (u/bem :heading [:large])}
           [:span.heading__pretext "Currently logged in as" [:span.u-hidden-from-view " "]]
           (cmn/curact app-atom [:user :name])]]]

        [:form.login-screen__form
         (forms/input
           "Password:" ""
           (rum/cursor unlock-atom :pwd)
           {:on-dark true :type :password
            :error (if (= error-field :pwd) true false)
            :hint (if (and (= error-field :pwd) error-message) error-message false)})]]

       [:aside.login-screen__footnote
        [:p.u-text-center.u-text-white
         {:class (u/bem :paragraph [:flush])}
         [:i {:class (u/bem :icon [:inline :in-copy-left :barcode-scan :2-2])}]
         "Scan tag to log in"]]]

      [:div.call-to-action
       (grid/row {:flush? true}
         (grid/cell {:span 1 :cols 2 :flush? true}
           (buttons/button
             "Log out"
             #(grid/dispatch-action app-atom :login/logout {})

             {:icon nil :full true :large true :secondary true}))

         (grid/cell {:span 1 :cols 2 :flush? true}
           (buttons/button
             "Unlock" #(grid/dispatch-action app-atom :pos/unlock-pwd @unlock-atom)
             {:full true :large true :call-to-action true})))]]]))

(defmethod flow/render-screen :lock [app-atom screen]
  (render-lock-screen app-atom))

(defmethod flow/barcode-dispatch-screen :lock [_ app-atom scan]
  (grid/dispatch-action app-atom :pos/unlock-scan {:scan scan}))

(defn validate-unlock [app-atom unlock manual?]
  (let [{:keys [pwd]} unlock
        error
        (when
          (and manual? (not (u/presence pwd)))
          {:error "Please enter a password" :error-field :pwd})]
    (if error
      (do (swap! app-atom merge error) false)
      true)))

(defmethod grid/action :pos/unlock-scan [app-atom {:keys [scan]}]
  (toaster/open-toast app-atom :processing "Unlocking" {})
  (comms/send :pos/unlock
    (->
      (get-in @app-atom [:unlock])
      (assoc :scan scan))))

(defmethod grid/action :pos/unlock-pwd [app-atom {:keys [pwd]}]
  (toaster/open-toast app-atom :processing "Unlocking" {})
  (when (validate-unlock app-atom {:pwd pwd} true)
    (comms/send :pos/unlock
      (->
        (get-in @app-atom [:unlock])
        (update :pwd #(when % (hash/md5 pwd)))))))

(defmethod comms/receive :pos/unlock [app-atom e]
  (toaster/close-toast app-atom)
  (t/transition-prev app-atom nil)

  (let [{:keys [login warehouse-list selected-warehouse]} @app-atom
        {:keys [warehouse_id]} login
        {:keys [displayname]} selected-warehouse

        warehouse-list
        (set
          (->>
            warehouse-list
            (filter :default)
            (map :warehouse-id)))]

    (comms/send :pos/keepaside-alerts {})
    (comms/send :pos/price-change-alert {})

    (when-not
      (contains? warehouse-list warehouse_id)
      (grid/dispatch-action app-atom :menu/open-default-warehouse-warning {}))))

;; Logout
(defmethod grid/action :login/logout [app-atom {}]
  (let [{:keys [warehouse-list blitz? login] :as app} @app-atom
        default-warehouse-ids (set (map :warehouse-id (filter :default warehouse-list)))
        current-warehouse-id (get-in app [:login :warehouse_id])
        conf {:warehouse-list (:warehouse-list app) :blitz? blitz?}
        conf
        (if (contains? default-warehouse-ids current-warehouse-id)
          (assoc conf :login {:warehouse_id current-warehouse-id})
          conf)]

    (cond
      blitz?
      (comms/send :presence/close {:context {:ent/uuid (get-in app [:login :warehouse_uuid])}})

      :else
      (comms/send :presence/close {:context {:ent/uuid (get-in app [:login :store_uuid])}}))
    (grid/dispatch-action app-atom :state/reset conf)))

(defmethod comms/receive :pos/logout [app-atom e]
  (cond
    (history/comms-disabled?)
    (toaster/open-toast app-atom :error (str "Dev ignoring:" (:warn e)) {:closetime 2000})

    :else
    (let [last-warehouse-id-used (u/get-local-storage (str "previous-warehouse"))]
      (grid/dispatch-action app-atom :state/reset {})
      (toaster/open-toast app-atom :error (:warn e) {:closetime 4000})
      (comms/send :pos/start
        (u/maybe assoc
          {:blitz? (trf/toboolean (:blitz? @app-atom))}
          :last-warehouse-id
          (when (u/presence last-warehouse-id-used)
            (trf/tonumber last-warehouse-id-used)))))))

